import { permissions } from '~/shared/lib'

export default function createMailRoutes() {
  const mailPermissions = permissions.PROJECTS.WORKSPACE.MAIL

  return [
    {
      name: mailPermissions.PERMISSION,
      path: mailPermissions.ROUTE,
      component: () => import('~/pages/mail/ui/MailPage.vue'),
    },
    {
      name: mailPermissions.APPEAL.PERMISSION,
      path: mailPermissions.APPEAL.ROUTE,
      component: () => import('~/pages/mail/ui/MailAppealPage.vue'),
    },
    {
      name: mailPermissions.CREATE.PERMISSION,
      path: mailPermissions.CREATE.ROUTE,
      component: () => import('~/pages/mail/ui/MailCreatePage.vue'),
    },
    {
      name: mailPermissions.DETAIL.PERMISSION,
      path: mailPermissions.DETAIL.ROUTE,
      component: () => import('~/pages/mail/ui/MailDetailPage.vue'),
    },
    {
      name: mailPermissions.REPLY.PERMISSION,
      path: mailPermissions.REPLY.ROUTE,
      component: () => import('~/pages/mail/ui/MailReplyPage.vue'),
      meta: {
        splitLayout: { leftRatio: 0.4, rightRatio: 0.6 },
      },
    },
  ]
}
